import React, { PropsWithChildren } from 'react';

import { Box, Text, ToggleTip } from '@betterment/samba-react';

export const DetailRowTooltip: React.FC<PropsWithChildren> = ({ children, ...props }) => {
  return (
    <Box css={{ display: 'flex', paddingLeft: 'space.50' }}>
      <ToggleTip>
        <ToggleTip.Trigger iconName="InfoCircle" label="Toggle Tip" {...props} />
        <ToggleTip.Content css={{ maxWidth: '325px' }} align="center" side="top">
          <Text>{children}</Text>
        </ToggleTip.Content>
      </ToggleTip>
    </Box>
  );
};
